// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"af216524","453":"670e15c7"}[chunkId] + ".chunk.js";
};